import { __decorate, __metadata } from "tslib";
import { nameOf } from '@goparrot/common';
import { ApiProperty, refs } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { ArrayNotEmpty, Equals, IsArray, ValidateNested } from 'class-validator';
import { PromotionExposeGroup, PromotionMustBuyConditionTypeEnum } from '../interface';
import { PutAbstractPromotionMustBuyConditionDto } from './PutAbstractPromotionMustBuyConditionDto';
import { PutPromotionCategoryMustBuyConditionDto } from './PutPromotionCategoryMustBuyConditionDto';
import { PutPromotionItemMustBuyConditionDto } from './PutPromotionItemMustBuyConditionDto';
export class PutPromotionCombinationMustBuyConditionDto extends PutAbstractPromotionMustBuyConditionDto {
    constructor() {
        super(...arguments);
        this.type = PromotionMustBuyConditionTypeEnum.COMBINATION;
    }
}
__decorate([
    ApiProperty({
        enum: [PromotionMustBuyConditionTypeEnum.COMBINATION],
        description: 'Combination of item or category must buy conditions',
        example: PromotionMustBuyConditionTypeEnum.COMBINATION,
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    Equals(PromotionMustBuyConditionTypeEnum.COMBINATION, { always: true }),
    __metadata("design:type", String)
], PutPromotionCombinationMustBuyConditionDto.prototype, "type", void 0);
__decorate([
    ApiProperty({
        description: 'Item or category must buy conditions that all should be fulfilled',
        oneOf: refs(PutPromotionItemMustBuyConditionDto, PutPromotionCategoryMustBuyConditionDto),
        isArray: true,
    }),
    Type(() => PutAbstractPromotionMustBuyConditionDto, {
        discriminator: {
            property: nameOf('type'),
            subTypes: [
                { name: PromotionMustBuyConditionTypeEnum.ITEM, value: PutPromotionItemMustBuyConditionDto },
                { name: PromotionMustBuyConditionTypeEnum.CATEGORY, value: PutPromotionCategoryMustBuyConditionDto },
            ],
        },
        keepDiscriminatorProperty: true,
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsArray({ always: true }),
    ArrayNotEmpty({ always: true }),
    ValidateNested({ always: true, each: true }),
    __metadata("design:type", Array)
], PutPromotionCombinationMustBuyConditionDto.prototype, "payload", void 0);
//# sourceMappingURL=PutPromotionCombinationMustBuyConditionDto.js.map